// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120306/js/" + chunkId + "." + {"44":"079af469","225":"306bfca1","481":"db64c1aa","486":"964d1c22","770":"657e89b4"}[chunkId] + ".0.2576389164376658.chunk.js";
};